module.exports = __webpack_public_path__ + "static/media/bytt-nn-20.cdc4ddb1.mp3";